// extracted by mini-css-extract-plugin
export default {"add-btn":"WWax1dbbVApn11iCcx55"};